if (!customElements.get('rb-navigation')) {
  customElements.define('rb-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.desktop = window.matchMedia('(min-width: 980px)');
      this.initLazyLinks(options);
      this.toggleButton = this.querySelector('.rb-nav__mobile-toggle');
      this.dropdowns = [...this.querySelectorAll('.rb-nav__dropdown')];
      this.trades = [...this.querySelectorAll('.rb-nav__trade')];
      this.toolGroups = [...this.querySelectorAll('.rb-nav__tool-group')];
      const setToolLayout = () => {
        this.toolGroups.forEach(group => { group.open = this.desktop.matches; });
      };
      setToolLayout();
      this.desktop.addEventListener('change', setToolLayout, options);
      const brands = this.querySelector('.rb-nav__groups--shop-by-brand');
      if (brands) {
        [...brands.children].sort((a, b) =>
          a.textContent.trim().replace(/^the\s+/i, '').localeCompare(
            b.textContent.trim().replace(/^the\s+/i, ''), 'en-GB', { sensitivity: 'base' }
          )
        ).forEach(brand => brands.appendChild(brand));
      }
      this.toggleButton.addEventListener('click', () => {
        const open = this.toggleAttribute('data-mobile-open');
        this.toggleButton.setAttribute('aria-expanded', String(open));
        if (!open) this.closeDropdowns();
      }, options);
      this.dropdowns.forEach(dropdown => {
        dropdown.addEventListener('toggle', () => {
          if (!dropdown.open) return;
          this.dropdowns.forEach(other => { if (other !== dropdown) other.open = false; });
          if (dropdown.classList.contains('rb-nav__trade-dropdown') && this.desktop.matches &&
              !this.trades.some(trade => trade.open)) this.trades[0].open = true;
          this.closest('store-header')?.classList.remove('is-out');
          if (!this.desktop.matches) {
            requestAnimationFrame(() => {
              if (!dropdown.open) return;
              const content = this.querySelector('.rb-nav__content');
              const summary = dropdown.querySelector('summary');
              content.scrollTop += summary.getBoundingClientRect().top -
                content.getBoundingClientRect().top - 12;
            });
          } else {
            const panel = dropdown.querySelector('.rb-nav__panel');
            if (panel) panel.scrollTop = 0;
          }
        }, options);
      });
      this.trades.forEach(trade => {
        trade.addEventListener('toggle', () => {
          if (trade.open && this.desktop.matches) {
            this.trades.forEach(other => { if (other !== trade) other.open = false; });
          }
        }, options);
        trade.querySelector('summary').addEventListener('keydown', event => {
          if (!this.desktop.matches || !['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = this.trades.indexOf(trade);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.trades.length - 1 :
            (index + (event.key === 'ArrowDown' ? 1 : -1) + this.trades.length) % this.trades.length;
          this.trades[next].open = true;
          this.trades[next].querySelector('summary').focus();
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const dropdown = event.target.closest('.rb-nav__dropdown[open]');
        if (dropdown) {
          dropdown.open = false;
          dropdown.querySelector('summary').focus();
        } else if (this.hasAttribute('data-mobile-open')) {
          this.removeAttribute('data-mobile-open');
          this.toggleButton.setAttribute('aria-expanded', 'false');
          this.toggleButton.focus();
        }
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, options);
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, options);
      this.desktop.addEventListener('change', () => this.closeAll(), options);
    }
    initLazyLinks(options) {
      this.lazyLists = [...this.querySelectorAll('ul[data-rb-lazy]')];
      if (!this.lazyLists.length) return;
      const load = () => this.loadLazyLinks();
      ['pointerover', 'focusin', 'touchstart', 'click'].forEach(type => {
        this.addEventListener(type, load, { ...options, passive: true });
      });
      const idle = () => ('requestIdleCallback' in window
        ? requestIdleCallback(load, { timeout: 3000 }) : setTimeout(load, 1500));
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { ...options, once: true });
    }
    loadLazyLinks() {
      if (this.lazyPromise || !this.lazyLists.length) return this.lazyPromise;
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('sections', 'rb-nav-panels');
      this.lazyPromise = fetch(url.toString(), { credentials: 'same-origin' })
        .then(response => (response.ok ? response.json() : Promise.reject(response.status)))
        .then(json => {
          const doc = new DOMParser().parseFromString(json['rb-nav-panels'] || '', 'text/html');
          const root = doc.querySelector('[data-rb-menu]');
          if (!root || root.dataset.rbMenu !== this.dataset.rbMenu) throw new Error('rb-nav-panels menu mismatch');
          this.lazyLists.forEach(list => {
            const source = root.querySelector(`template[data-rb-key="${list.dataset.rbLazy}"]`);
            if (source) list.appendChild(document.importNode(source.content, true));
            list.removeAttribute('data-rb-lazy');
          });
          this.lazyLists = [];
        })
        .catch(error => {
          this.lazyPromise = null;
          console.warn('rb-navigation: third-level links not loaded', error);
        });
      return this.lazyPromise;
    }
    closeDropdowns() { this.dropdowns.forEach(dropdown => { dropdown.open = false; }); }
    closeAll() {
      this.closeDropdowns();
      this.removeAttribute('data-mobile-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
